export default __webpack_public_path__ + "static/UNA-31ec15630ce381a528c1f1172a1e75fd.webp";